// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';

type Props = {
  minimum: number,
  maximum: number,
  isMaximumLastPage: boolean,
  current: number,
  onPageChanged: (page: number) => void
};

class Pagination extends PureComponent<Props> {
  getPagesNumber = (minimum: number, maximum: number) => {
    const pagesNumber = [];
    for (let i = minimum; i <= maximum; i++) {
      pagesNumber.push(i);
    }

    return pagesNumber;
  };

  onClick = (index: number) => (e: MouseEvent) => {
    e.preventDefault();
    this.props.onPageChanged(index);
  };

  renderPaginationElements = (minimum: number, maximum: number, isMaximumLastPage: boolean, current: number): any => {
    const pages = this.getPagesNumber(minimum, maximum);

    return pages.map((pageNumber, index) => {
      const classNamesPageNumber = dynamicClassName('');
      current === pageNumber && classNamesPageNumber.add(`${'is-active'} ${pageNumber}`);

      if (index === current - 2 || index === current - 1 || index === current ) {
        return (
          <li key={pageNumber}>
            <Link to="#" className={classNamesPageNumber.build()} onClick={this.onClick(pageNumber)}>
              {pageNumber}
            </Link>
          </li>
        );
      }
      if (index === 0 ) {
        return (
          <li key={pageNumber}>
            <Link to="#" className={classNamesPageNumber.build()} onClick={this.onClick(pageNumber)}>
              {pageNumber}
            </Link>
          </li>
        );
      }
      if (index === maximum - 1 ) {
        return (
          <li key={pageNumber}>
            <Link to="#" className={classNamesPageNumber.build()} onClick={this.onClick(pageNumber)}>
              {pageNumber}
            </Link>
          </li>
        );
      }
      if (index === current - 3 || index === current + 1 ) {
        return (
          <li key={pageNumber}>
            ...
          </li>
        );
      }

      return null;
    });
  };

  render() {
    const { current } = this.props;
    const classNamesPaginationPrev = dynamicClassName('pagination__prev');
    this.props.minimum === current && classNamesPaginationPrev.add('is-disabled');
    const classNamesPaginationNext = dynamicClassName('pagination__next');
    this.props.maximum === current && classNamesPaginationNext.add('is-disabled');

    return (
      <ul className="pagination mt-4">
        <li className={classNamesPaginationPrev.build()}>
          <Link to="#" onClick={this.onClick(current - 1)}>
            <i className="icon icon-chevron-left" />
          </Link>
        </li>
        {this.renderPaginationElements(
          this.props.minimum,
          this.props.maximum,
          this.props.isMaximumLastPage,
          this.props.current
        )}
        <li className={classNamesPaginationNext.build()}>
          <Link to="#" onClick={this.onClick(current + 1)}>
            <i className="icon icon-chevron-right" />
          </Link>
        </li>
      </ul>
    );
  }
}

export default Pagination;
